import React from 'react';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {useControllerProps} from '../../../../../domain/controllers/ControllerContext';
import {classes} from './PriceBreakdown.st.css';
import {Divider} from '@wix/wix-ui-tpa/cssVars';
import {CouponTotal} from '../../../../../common/components/CouponTotal/CouponTotal';
import {PriceBreakdownSkeleton} from './Skeleton/Skeleton';
import {SubtotalAmount} from './SubtotalAmount/SubtotalAmount';
import {Discounts} from '../../../../../common/components/Discounts/Discounts';
import {Fees} from '../../../../../common/components/Fees/Fees';

export enum PriceBreakdownDataHooks {
  priceBreakdownDivider = 'PriceBreakdown.priceBreakdownDivider',
  priceBreakdownContainer = 'PriceBreakdown.priceBreakdownContainer',
  priceBreakdownSkeleton = 'PriceBreakdown.priceBreakdownSkeleton',
}

export const PriceBreakdown = () => {
  const {t} = useTranslation();
  const {
    cartModel,
    cartSummary: estimatedTotals,
    isSummaryUpdating,
    revampDiscountsInCartAndCheckout,
  } = useControllerProps().cartStore;
  const {shouldDisplaySummaryDiscounts, shouldDisplayAdditionalFees} = useControllerProps().orderStore;

  const appliedCoupon = cartModel.coupon;
  const isCouponApplied = !!appliedCoupon;
  const hasDiscounts = revampDiscountsInCartAndCheckout ? shouldDisplaySummaryDiscounts : isCouponApplied;
  const shouldShowBreakdown = hasDiscounts || shouldDisplayAdditionalFees;
  const subtotalAmount =
    estimatedTotals?.priceSummary.subtotal.formattedConvertedAmount ?? cartModel.subtotal?.formattedConvertedAmount;

  return (
    <div>
      {shouldShowBreakdown && (
        <>
          <Divider className={classes.divider} data-hook={PriceBreakdownDataHooks.priceBreakdownDivider} />
          <div className={classes.container} data-hook={PriceBreakdownDataHooks.priceBreakdownContainer}>
            {isSummaryUpdating ? (
              <PriceBreakdownSkeleton />
            ) : (
              <>
                <SubtotalAmount subtotalAmount={subtotalAmount} />
                {hasDiscounts &&
                  (revampDiscountsInCartAndCheckout ? (
                    <Discounts shouldShowDivider={false} />
                  ) : (
                    <CouponTotal shouldShowDivider={false} />
                  ))}
                {shouldDisplayAdditionalFees && (
                  <Fees
                    fees={estimatedTotals.additionalFees}
                    groupTitle={t('cart.additionalFees')}
                    shouldShowDivider={false}
                  />
                )}
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};
